import React, { useState } from 'react';
import styled from 'styled-components';
import { Button } from '../../../../smart-home-support/components';
import { StyledTextArea } from './TextArea';
import { TagData } from './TagOptionsMap';

const TextArea = styled(StyledTextArea)`
  font-size: 0.8rem;
  resize: vertical;
  border: 1px solid #cdcdcd;
  padding: 0.25rem;
  border-radius: 4px;
  width: 96%;
  &:placeholder {
    color: #9b9b9b;
    font-size: 0.8rem;
  }
`;

const StyledButtonContainer = styled.div``;

const StyledSubmitButton = styled(Button)`
  text-align: center;
  width: 96%;
  padding-right: 6rem;
  padding-left: 6rem;
  min-height: 48px;
  max-height: 48px;
  margin: 0.5rem 0;

  @media (max-width: 768px) {
    max-width: 15.5rem;
  }
`;

const OtherInformationLabelText = styled.label`
  font-size: 14px;
  font-weight: bold;
  margin: 1rem 0;
`;

const OtherInformationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-content: center;
  max-width: 15rem;
  width: 90%;
`;

export const OtherInformationField = ({
  onCommentSend,
  otherTag,
}: {
  onCommentSend(message: string, otherTag: TagData): void;
  otherTag: TagData;
}) => {
  const [commentText, setCommentText] = useState<string>('');
  const handleInputChange = (event: any) => event && event.target && setCommentText(event.target.value);
  const onButtonClick = () => {
    onCommentSend(commentText, otherTag);
  };

  return otherTag ? (
    <OtherInformationContainer>
      <OtherInformationLabelText>
        {otherTag.labelInputText}
        <TextArea
          aria-label="Leave a comment"
          cols={40}
          rows={2}
          placeholder="Leave a specific comment"
          onChange={handleInputChange}
        />
      </OtherInformationLabelText>
      <StyledButtonContainer>
        <StyledSubmitButton disabled={commentText.length === 0} onClick={onButtonClick}>
          Submit
        </StyledSubmitButton>
      </StyledButtonContainer>
    </OtherInformationContainer>
  ) : null;
};



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/FiveStarSurvey/components/OtherInformationField.tsx